const content = {
	createTemplateButtonText: 'Create Payment Template',
	header: 'Payment templates',
	chapsHeader: 'CHAPS payment templates',
	descriptionNoTemplates:
		'Create templates for regular payments like wages and invoices so you don’t have to enter the same details all the time. It’s quick, simple and convenient – and you can update your template at any time.',

	description: 'Make a payment using a template you’ve previously saved or create a new one now.',
};

export default content;
